import { create } from "zustand";

const useCourseIdStore = create((set) => ({
  courseId: null,
  setCourseId: (id) => set({ courseId: id }), 
}));

export default useCourseIdStore;
